import { render, staticRenderFns } from "./BowContentStickyMediaDx.vue?vue&type=template&id=5cd2f9d7&"
import script from "./BowContentStickyMediaDx.vue?vue&type=script&lang=js&"
export * from "./BowContentStickyMediaDx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowContentStickyMedia: require('/workspace/components/organisms/BowContentStickyMedia/BowContentStickyMedia.vue').default})
